import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=75bc807e&scoped=true"
import script from "./sticky.vue?vue&type=script&lang=ts"
export * from "./sticky.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./sticky.vue?vue&type=style&index=0&id=75bc807e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "75bc807e",
  "d4214006"
  
)

export default component.exports